import { apiFetch } from "./api";

export interface ChatConversation {
  id: string;
  user_id: string;
  client_id: string;
  topic: string | null;
  module_id: string;
  created_at: string;
  unread?: boolean;
}

export interface ChatMessage {
  id: string;
  conversation_id: string;
  sender: "user" | "chatbot";
  type: "text" | "audio";
  content: string;
  reaction: "like" | "dislike" | null;
  has_error?: boolean;
  created_at: string;
}

export interface ListConversationsResponse {
  conversations: ChatConversation[];
  next_cursor?: string;
}

export interface ListMessagesResponse {
  messages: ChatMessage[];
  next_cursor?: string;
}

export interface CreateConversationResponse {
  conversation: ChatConversation;
  message: ChatMessage;
}

export function listConversations(moduleId?: string, clientId?: string, cursor?: string, limit = 20) {
  const params = new URLSearchParams({ limit: String(limit) });
  if (cursor) params.set("cursor", cursor);
  if (moduleId) params.set("module_id", moduleId);
  if (clientId) params.set("client_id", clientId);
  return apiFetch<ListConversationsResponse>(`/api/chats?${params.toString()}`);
}

export function createConversation(clientId: string, moduleId: string, content: string, topic?: string) {
  return apiFetch<CreateConversationResponse>("/api/chats", {
    method: "POST",
    body: JSON.stringify({ client_id: clientId, module_id: moduleId, topic: topic ?? null, content }),
  });
}

export function deleteConversation(id: string) {
  return apiFetch<void>(`/api/chats/${id}`, { method: "DELETE" });
}

export function updateConversation(id: string, topic: string) {
  return apiFetch<ChatConversation>(`/api/chats/${id}`, { method: "PUT", body: JSON.stringify({ topic }) });
}

export function listMessages(conversationId: string, cursor?: string, limit = 50) {
  const params = new URLSearchParams({ limit: String(limit) });
  if (cursor) params.set("cursor", cursor);
  return apiFetch<ListMessagesResponse>(`/api/chats/${conversationId}/messages?${params.toString()}`);
}

export function sendMessage(conversationId: string, content: string) {
  return apiFetch<ChatMessage>(`/api/chats/${conversationId}/messages`, {
    method: "POST",
    body: JSON.stringify({ content }),
  });
}

export function markConversationAsRead(id: string) {
  return apiFetch<void>(`/api/chats/${id}/read`, { method: "POST" });
}

export function setReaction(conversationId: string, messageId: string, reaction: "like" | "dislike" | null) {
  return apiFetch<ChatMessage>(`/api/chats/${conversationId}/messages/${messageId}/reaction`, {
    method: "PUT",
    body: JSON.stringify({ reaction }),
  });
}
